import { Component } from "react";

import { aplicarActualizacion, hayActualizacionPendiente } from "../../pwa";

/* UNA VERSIÓN VIEJA NO ES UNA PANTALLA ROTA (05/10, Igna con «Pedidos de
 * chóferes»: «Loading chunk 529 failed»). Las pantallas que se cargan aparte
 * (`lazy` en App.jsx) piden su archivo recién cuando alguien entra. Si en el
 * medio se desplegó una versión nueva, ese archivo ya no existe —cada deploy
 * les cambia el nombre— y la pestaña abierta desde antes lo pide igual. No hay
 * nada roto: falta tomar la versión nueva. Así que se toma sola: se aplica la
 * actualización pendiente o se recarga, UNA vez por minuto —si el archivo
 * sigue faltando después de recargar, es otra cosa y se muestra el cartel—. */
const CLAVE_RECARGA = "hub.recargaPorVersionVieja";

export function esVersionVieja(error) {
  const nombre = String(error?.name || "");
  const msg = String(error?.message || error || "");
  return nombre === "ChunkLoadError"
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(msg)
    || /Failed to fetch dynamically imported module/i.test(msg);
}

/* Si corresponde recargar. Recuerda la última vez en sessionStorage para no
 * entrar en un bucle; si el navegador no deja guardar, no recarga. */
export function tocaRecargar(ahora = Date.now()) {
  try {
    const antes = Number(window.sessionStorage.getItem(CLAVE_RECARGA) || 0);
    if (ahora - antes < 60000) return false;
    window.sessionStorage.setItem(CLAVE_RECARGA, String(ahora));
    return true;
  } catch {
    return false;
  }
}

function tomarVersionNueva() {
  if (hayActualizacionPendiente()) aplicarActualizacion();
  else window.location.reload();
}

/* Si una pantalla se rompe, que se rompa SOLA.
 *
 * QUÉ PASÓ. `/documentacion` llamaba a `permisos.has(...)` y `permisos` es un
 * array, no un Set. Eso tira un TypeError en el render, y sin nada que lo
 * atrape React desmonta el árbol entero: **el hub queda en blanco**. No la
 * pantalla — el hub. El rail, la cabecera y todo lo demás.
 *
 * El error de la pantalla se arregla en una línea; que se llevara puesto el
 * sitio entero es el problema de verdad, y no lo iba a resolver ese arreglo.
 * Con veinte pantallas y gente entrando por primera vez, la próxima que falle
 * va a fallar igual.
 *
 * QUÉ SE PROTEGE, Y ES LO QUE DECIDE DÓNDE VA. Envuelve el `Outlet`, o sea el
 * CONTENIDO. El rail, la cabecera y el selector de tema quedan afuera y siguen
 * andando: con eso la persona se va a otra pantalla y sigue trabajando. Puesto
 * más arriba protegería más código y dejaría exactamente la misma pantalla en
 * blanco, sin salida.
 *
 * SE VUELVE A INTENTAR AL CAMBIAR DE PANTALLA. Un límite de error se queda
 * "roto" hasta que alguien lo resetea; sin eso, volver a la pantalla que falló
 * —o ir a cualquier otra— seguiría mostrando el cartel. `key={pathname}` lo
 * remonta en cada ruta, así que el error dura lo que dura esa pantalla.
 *
 * NO DICE «recargá la página» Y NADA MÁS. Recargar es lo que la gente ya
 * intentó, y en un error de render vuelve a fallar igual. Lo que sirve es
 * salir a otra pantalla, y eso es lo que se ofrece.
 *
 * Y EL DETALLE TÉCNICO SE MUESTRA, plegado. Sin él, "algo se rompió" obliga a
 * pedir una captura de la consola —que nadie sabe abrir— y a adivinar. Con el
 * mensaje, el que reporta puede copiarlo y el arreglo empieza sabiendo qué
 * pasó.
 */
class SiSeRompe extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (esVersionVieja(error) && tocaRecargar()) {
      tomarVersionNueva();
      return;
    }
    // Queda en la consola para el que sepa mirarla, sin depender de eso.
    console.error("[hub] se rompió una pantalla:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    if (esVersionVieja(this.state.error)) {
      return (
        <div className="se-rompio">
          <h2>Hay una versión nueva del hub</h2>
          <p>
            Esta pantalla cambió desde que abriste el hub. Actualizá para
            verla: <b>no se pierde nada</b>.
          </p>
          <button className="btn btn--primary" onClick={tomarVersionNueva}>
            Actualizar
          </button>
        </div>
      );
    }

    const msg = String(this.state.error?.message || this.state.error);
    return (
      <div className="se-rompio">
        <h2>Esta pantalla se rompió</h2>
        <p>
          El resto del sistema sigue andando: elegí otra en el menú de la
          izquierda y seguí trabajando. <b>No se perdió nada de lo que estaba
          guardado</b> — lo que falló fue mostrar esta pantalla, no los datos.
        </p>
        <p className="se-rompio-pedir">
          Si te podés tomar un segundo, mandá esta línea junto con el nombre de
          la pantalla: es lo que hace que el arreglo empiece sabiendo qué pasó
          en vez de adivinando.
        </p>
        <pre>{msg}</pre>
      </div>
    );
  }
}

export default SiSeRompe;
